import React, { useMemo } from 'react';
import { ChecklistDataEntry, MotorChecklistType, StudentChecklistValue } from './types';
import { createColumnHelper } from '@tanstack/react-table';
import { useTranslation } from 'react-i18next';
import ChecklistValueCell from './ChecklistValueCell';
import Table from './Table';

type MotorChecklistDataEntry = ChecklistDataEntry & {
	healthDeclaration: StudentChecklistValue;
	theoryExam: StudentChecklistValue;
	avbExam: StudentChecklistValue;
	avdExam: StudentChecklistValue;
};
const columnHelper = createColumnHelper<MotorChecklistDataEntry>();

const MotorChecklist = ({ checklist }: { checklist: MotorChecklistType }) => {
	const { t } = useTranslation();

	const columns = useMemo(() => {
		return [
			columnHelper.accessor('student.lastName', {
				header: t('employees.lastName'),
			}),
			columnHelper.accessor('student.firstName', {
				header: t('employees.firstName'),
			}),
			columnHelper.accessor('healthDeclaration', {
				header: 'Gezondheidsverklaring',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('theoryExam', {
				header: 'Theorie-examen',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('avbExam', {
				header: 'AVB',
				cell: ChecklistValueCell,
			}),
			columnHelper.accessor('avdExam', {
				header: 'AVD',
				cell: ChecklistValueCell,
			}),
		];
	}, []);

	const data = useMemo(() => {
		return checklist.checklists.map((entry) => ({
			student: entry.student,
			healthDeclaration: entry.values.find(
				(value) => value.option.name === 'Gezondheidsverklaring',
			) || { value: null },
			theoryExam: entry.values.find((value) => value.option.name === 'Theorie-examen') || {
				value: null,
			},
			avbExam: entry.values.find((value) => value.option.name === 'AVB') || { value: null },
			avdExam: entry.values.find((value) => value.option.name === 'AVD') || { value: null },
		}));
	}, [checklist]);

	return <Table data={data} columns={columns} />;
};

export default MotorChecklist;
